import { ref, Ref } from 'vue';
import isEmail from 'validator/lib/isEmail';
import { FormLabel, LABEL_INVALID_EMAIL, LABEL_RECOVERY_HELP, LABEL_FIELD_INVALID, LABEL_EMAIL, LABEL_INTERNAL_DOMAIN } from './form';
import { ServerValidationError } from './registrationState';
import { LABEL_TOO_MANY_ACCOUNTS_FOR_MAILADDRESS, LABEL_REGISTRATION_CTEMPLAR } from './i18nLabels';

/**

 */
export interface Result {
  email: Ref<string>;
  isEmailInvalid: Ref<boolean>;
  emailMessage: Ref<FormLabel | null>;
  displayServerValidationError(err: ServerValidationError, serviceName: string): void;
  validate(type: 'b' | 'k' | ''): void;
}

const useRecoveryEmailValidation = (): Result => {
  const email = ref('');
  const emailMessage: Ref<FormLabel | null> = ref({ label: LABEL_RECOVERY_HELP });
  const isEmailInvalid = ref(false);

  function clearRecoveryEmail() {
    isEmailInvalid.value = false;
    emailMessage.value = {
      label: LABEL_RECOVERY_HELP,
    };
  }

  function validate(type: 'b' | 'k' | '') {
    const wasValid = !isEmailInvalid.value;
    const isKeypress = type === 'k';
    const isBlur = type === 'b';
    const emailValue = email.value;

    if (isKeypress && wasValid) {
      // wait blur before validating
      return;
    }

    if (isBlur && emailValue.length === 0) {
      clearRecoveryEmail();
      return;
    }

    if (!isEmail(emailValue)) {
      isEmailInvalid.value = true;
      emailMessage.value = { label: LABEL_INVALID_EMAIL };
      return;
    }

    if (emailValue.toLowerCase().endsWith('@ctemplar.com')) {
      isEmailInvalid.value = true;
      emailMessage.value = { label: LABEL_REGISTRATION_CTEMPLAR };
      return;
    }

    clearRecoveryEmail();
  }

  function displayServerValidationError(err: ServerValidationError, serviceName: string) {
    const { code } = err;
    let { field = '' } = err;

    // Lower case field name
    field = field.toLowerCase();

    switch (field) {
      case 'recoveryemail':
        isEmailInvalid.value = true;

        if (code === 'DISPOSABLE_EMAIL_NOT_ALLOWED') {
          emailMessage.value = { label: LABEL_FIELD_INVALID, params: [{ label: LABEL_EMAIL }] };
        } else if (code === 'INTERNAL_EMAIL_NOT_ALLOWED') {
          emailMessage.value = { label: LABEL_INTERNAL_DOMAIN, params: [{ label: serviceName || '' }] };
        } else if (code && code.indexOf('TOO_MANY_ACCOUNT') === 0) {
          // Too many account registered for this email
          emailMessage.value = { label: LABEL_TOO_MANY_ACCOUNTS_FOR_MAILADDRESS };
        } else {
          emailMessage.value = { label: LABEL_FIELD_INVALID, params: [{ label: LABEL_EMAIL }] };
        }

        break;

      default:
        break;
    }
  }

  return {
    email,
    emailMessage,
    isEmailInvalid,
    displayServerValidationError,
    validate,
  };
};

export default useRecoveryEmailValidation;
